import type { CSSProperties, ReactNode } from 'react';
import { BackButton } from '../../common-buttons/BackButton';
import { dataEl, type DataElScope } from '@/utils/dataEl';
interface CstretchmodalBackButtonProps {
    canClose: boolean;
    dataElScope: DataElScope;
    onClick: () => void;
    showBackButton: boolean;
    style: CSSProperties;
}
export function CstretchmodalBackButton({ canClose, dataElScope, onClick, showBackButton, style, }: CstretchmodalBackButtonProps): ReactNode {
    if (!showBackButton || !canClose) {
        return false;
    }
    return (
      <div data-el={dataEl(dataElScope, 'BackButton/Root')} style={style}>
        <BackButton onClick={onClick}/>
      </div>
    );
}
